// packages/0-foundation/core.module/src/v1/_universal/lvl_1/logger.part/utils/_parts/lvl_2/log-replacer.util.ts

import { MAX_STRING_LENGTH, trimString } from "../lvl_1";

export function createLogReplacer(omitKeys: string[] = []) {
  return (key: string, value: unknown): unknown => {
    if (key === "") return value;

    if (omitKeys.includes(key)) {
      return undefined;
    }

    if (typeof value === "string" && value.length > MAX_STRING_LENGTH) {
      return trimString(value);
    }

    return value;
  };
}
